import * as React from 'react';

const LeftArrow = (props) => (
  <svg
    width={props.width}
    height={props.width}
    fill={props.fill}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.571 18.82c-.19 0-.38-.07-.53-.22l-6.07-6.07a.754.754 0 0 1 0-1.06l6.07-6.07c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06L4.561 12l5.54 5.54c.29.29.29.77 0 1.06-.14.15-.34.22-.53.22Z"
      fill={props.fill}
    />
    <path
      d="M20.502 12.75H3.672c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h16.83c.41 0 .75.34.75.75s-.34.75-.75.75Z"
      fill={props.fill}
    />
  </svg>
);

LeftArrow.defaultProps = {
  width: 24,
  height: 24,
  fill: '#475569'
};

export { LeftArrow };
